import { useAuth } from "@clerk/nextjs";
import { useQuery } from "@tanstack/react-query";
import { BOOKMARK_LISTNAME_FAVORITE } from "constants/config";
import { getBookmarkLists } from "helpers/api";
import { IBookmarkListItem } from "helpers/bookmark";
import { QUERY_KEYS } from "features/Bookmarks/hooks/useBookmarks";

export const useBookmarkLists = (enabled: boolean = true) => {
  const { isSignedIn, isLoaded, userId } = useAuth();

  const { data: bookmarkLists = [], isLoading } = useQuery(
    [...QUERY_KEYS.BOOKMARK_LISTS, userId],
    async (): Promise<IBookmarkListItem[]> => {
      try {
        const listResponse = await getBookmarkLists(BOOKMARK_LISTNAME_FAVORITE);
        return listResponse?.bookmark_lists || [];
      } catch (error) {
        console.error("Failed to fetch bookmark lists:", error);
        return [];
      }
    },
    {
      enabled: enabled && isSignedIn && isLoaded,
    }
  );

  return {
    bookmarkLists,
    isLoading,
  };
};
